var _path, _rect, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToyotaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1",
    "data-name": "Group 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 144.417,
    height: 38.582,
    viewBox: "0 0 144.417 38.582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M620.226,239.691l2.26-5.929,2.258,5.929Zm4.609-9.3h-4.7l-6.563,16.077h4.068l1.494-3.923h6.7l1.5,3.923h4.067ZM591.71,243.677a5.373,5.373,0,1,1,4.794-5.341,5.088,5.088,0,0,1-4.794,5.341m0-13.833a8.491,8.491,0,1,0,8.494,8.492,8.491,8.491,0,0,0-8.494-8.492m-33.517,13.833a5.372,5.372,0,1,1,4.8-5.341,5.089,5.089,0,0,1-4.8,5.341m0-13.833a8.491,8.491,0,1,0,8.494,8.492,8.491,8.491,0,0,0-8.494-8.492m21,.551-4.162,6.5-4.165-6.5h-4.07l6.441,10.082v5.995h3.582v-5.993l6.442-10.083Zm35.244,0H600.684v3.083h5.092v12.994h3.586V233.478h5.069Zm-79.225,3.083H540.3v12.994h3.584V233.478h5.071V230.4H535.206Z",
    transform: "translate(-486.978 -219.184)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 38.582,
    height: 38.582,
    fill: "#eb0a1e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M329.539,227.271a23.06,23.06,0,0,0-12.868,0c-4.763,1.531-8.035,4.711-8.035,8.385,0,5.169,6.478,9.361,14.469,9.361s14.468-4.191,14.468-9.361c0-3.674-3.272-6.853-8.034-8.385m-6.434,13.721c-1.193,0-2.166-2.345-2.223-5.291.717.065,1.461.1,2.223.1s1.505-.034,2.222-.1c-.057,2.946-1.031,5.291-2.222,5.291m-2.073-7.6c.326-2.068,1.13-3.533,2.073-3.533s1.747,1.465,2.072,3.533c-.662.06-1.357.093-2.072.093s-1.41-.033-2.073-.093m5.412-.156c-.484-3.246-1.8-5.573-3.339-5.573s-2.856,2.327-3.34,5.573c-2.939-.459-4.993-1.5-4.993-2.719,0-1.639,3.731-2.968,8.333-2.968s8.334,1.329,8.334,2.968c0,1.217-2.054,2.261-4.994,2.719m-15.7,2.075a6.761,6.761,0,0,1,1.674-4.347,1.991,1.991,0,0,0-.019.268c0,1.992,2.994,3.688,7.169,4.31,0,.151-.006.3-.006.454,0,3.706,1.028,6.846,2.449,7.928-6.315-.386-11.268-4.094-11.268-8.613m13.447,8.613c1.421-1.082,2.448-4.222,2.448-7.928,0-.153,0-.3-.005-.454,4.174-.623,7.168-2.318,7.168-4.31a1.986,1.986,0,0,0-.019-.268,6.763,6.763,0,0,1,1.674,4.347c0,4.519-4.953,8.227-11.267,8.613",
    transform: "translate(-303.813 -216.363)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToyotaLogo);
export default __webpack_public_path__ + "static/media/Toyota-logo.a8b272a7ed4290cc686f698c9b63136c.svg";
export { ForwardRef as ReactComponent };